/* Lucky Number 24 — creator / discount codes (v2, Oct 2026).
   - No floating pill anymore. The code box lives in the buy step: Number Detail page, right above "Select this number".
   - Creator links (luckynumber24.com/?code=MICK10, ?ref=, ?discount=) still apply the code automatically on any page.
   - The code is remembered 30 days in this browser and added to every checkout request (number detail + vanity cards),
     where Shopify applies it to the draft order (extra % off) and tags the order for the creator's commission.
   - Why not at Shopify checkout: invoice (draft order) checkouts have no discount-code field. */
(function(){
  if(window.__ln24Code)return;window.__ln24Code=1;
  var API='https://numberbarn-checkout-api.vercel.app/api/create-order';
  var KEY='ln24_code';
  var L=(document.documentElement.getAttribute('lang')||'en').toLowerCase();
  var LG=L.indexOf('th')===0?'th':(L.indexOf('zh')===0?'zh':'en');
  var T={
    en:{have:'🎟️ Have a discount code?',ph:'Enter code',apply:'Apply',checking:'Checking…',bad:'That code isn’t valid or has expired.',on:function(c,p){return '✓ '+c+' applied · extra '+p+'% off at checkout';},now:function(v){return 'Your price with code: about $'+v;},toast:function(c,p){return '🎉 Code '+c+' applied — extra '+p+'% off at checkout';},remove:'Remove'},
    th:{have:'🎟️ มีโค้ดส่วนลดไหม?',ph:'ใส่โค้ด',apply:'ใช้โค้ด',checking:'กำลังเช็ก…',bad:'โค้ดนี้ใช้ไม่ได้หรือหมดอายุแล้ว',on:function(c,p){return '✓ ใช้โค้ด '+c+' แล้ว · ลดเพิ่ม '+p+'% ตอนชำระเงิน';},now:function(v){return 'ราคาหลังใช้โค้ด ประมาณ $'+v;},toast:function(c,p){return '🎉 ใช้โค้ด '+c+' แล้ว — ลดเพิ่ม '+p+'% ตอนชำระเงิน';},remove:'เอาออก'},
    zh:{have:'🎟️ 有折扣碼嗎？',ph:'輸入折扣碼',apply:'套用',checking:'確認中…',bad:'此折扣碼無效或已過期。',on:function(c,p){return '✓ 已套用 '+c+' · 結帳再享 '+p+'% 折扣';},now:function(v){return '使用折扣碼後約 $'+v;},toast:function(c,p){return '🎉 已套用 '+c+' — 結帳再享 '+p+'% 折扣';},remove:'移除'}
  }[LG];

  function load(){try{var v=JSON.parse(localStorage.getItem(KEY)||'null');if(v&&v.code&&(Date.now()-v.ts)<1000*60*60*24*30)return v;}catch(e){}return null;}
  function save(v){try{if(v)localStorage.setItem(KEY,JSON.stringify(v));else localStorage.removeItem(KEY);}catch(e){}}
  var S={cur:load()};

  /* attach the remembered code to every checkout request */
  var of=window.fetch;
  window.fetch=function(u,o){
    try{
      var url=typeof u==='string'?u:(u&&u.url)||'';
      if(S.cur&&url.indexOf('/api/create-order')>-1&&o&&o.body&&typeof o.body==='string'){
        var b=JSON.parse(o.body);
        if(b&&b.validateCode===undefined&&!b.code){b.code=S.cur.code;o=Object.assign({},o,{body:JSON.stringify(b)});}
      }
    }catch(e){}
    return of.call(this,u,o);
  };
  function validate(code){
    return of.call(window,API,{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({validateCode:code})}).then(function(r){return r.json();});
  }

  var css='.ln24cb{margin:14px 0 4px;text-align:left}'+
    '.ln24cb *{box-sizing:border-box;font-family:inherit}'+
    '.ln24cb-link{background:none;border:none;padding:0;color:#3D1E3F;font-weight:700;text-decoration:underline;text-underline-offset:4px;cursor:pointer}'+
    '.ln24cb-row{display:none;gap:8px;margin-top:10px}'+
    '.ln24cb.open .ln24cb-row{display:flex}'+
    '.ln24cb-row input{flex:1;min-width:0;padding:10px 14px;border-radius:12px;border:1px solid #E1D5EA;text-transform:uppercase;color:#2A1530;outline:none;background:#fff}'+
    '.ln24cb-row input:focus{border-color:#B8935A;box-shadow:0 0 0 3px rgba(212,176,108,.25)}'+
    '.ln24cb-row button{padding:10px 16px;border-radius:12px;border:none;background:linear-gradient(135deg,#3D1E3F,#B8935A);color:#fff;font-weight:700;cursor:pointer;white-space:nowrap}'+
    '.ln24cb-msg{margin-top:6px;color:#9b1c1c}'+
    '.ln24cb-on{display:none;background:#F4EEF8;border:1px solid #E1D5EA;border-radius:12px;padding:10px 14px;color:#3D1E3F;font-weight:700}'+
    '.ln24cb.has .ln24cb-on{display:block}.ln24cb.has .ln24cb-link,.ln24cb.has .ln24cb-row{display:none!important}'+
    '.ln24cb-on small{display:block;font-weight:400;color:#6E6072;margin-top:2px}'+
    '.ln24cb-on button{background:none;border:none;color:#9b1c1c;text-decoration:underline;cursor:pointer;padding:0;margin-left:6px;font-weight:400}'+
    '.ln24c-toast{position:fixed;left:50%;top:18px;transform:translate(-50%,-20px);opacity:0;background:#3D1E3F;color:#FFE9B8;font-size:16px;padding:12px 20px;border-radius:999px;box-shadow:0 12px 30px rgba(42,21,48,.3);z-index:2147483001;transition:opacity .35s ease,transform .35s ease;max-width:calc(100vw - 24px);text-align:center;pointer-events:none}'+
    '.ln24-sub .ln24c-toast{font-size:24px}'+
    '.ln24c-toast.show{opacity:1;transform:translate(-50%,0)}';
  var st=document.createElement('style');st.textContent=css;document.head.appendChild(st);

  var toast=document.createElement('div');toast.className='ln24c-toast';
  function showToast(t){toast.textContent=t;toast.classList.add('show');setTimeout(function(){toast.classList.remove('show');},4200);}

  var box=null;
  function basePrice(){
    var p=document.querySelector('.ln24d-buybox .ln24d-price-big');if(!p)return 0;
    var txt=Array.prototype.filter.call(p.childNodes,function(n){return n.nodeType===3;}).map(function(n){return n.textContent;}).join('');
    var m=txt.replace(/,/g,'').match(/\d+(\.\d+)?/);return m?parseFloat(m[0]):0;
  }
  function paint(){
    if(!box)return;
    var c=S.cur;box.classList.toggle('has',!!c);
    if(c){
      var bp=basePrice(),line=T.on(c.code,c.percent);
      box.querySelector('.ln24cb-on span').textContent=line;
      box.querySelector('.ln24cb-on small').textContent=bp?T.now(Math.round(bp*(100-c.percent)/100)):'';
    }
  }
  function apply(code,quiet){
    code=String(code||'').trim().toUpperCase();if(!code)return;
    var msg=box&&box.querySelector('.ln24cb-msg'),btn=box&&box.querySelector('.ln24cb-row button');
    if(msg){msg.style.color='#6E6072';msg.textContent=T.checking;}if(btn)btn.disabled=true;
    validate(code).then(function(j){
      if(btn)btn.disabled=false;
      if(j&&j.valid){S.cur={code:j.code,percent:j.percent,ts:Date.now()};save(S.cur);if(msg)msg.textContent='';paint();showToast(T.toast(j.code,j.percent));}
      else if(msg){msg.style.color='#9b1c1c';msg.textContent=T.bad;if(box){box.classList.add('open');box.querySelector('input').value=code;}}
    }).catch(function(){if(btn)btn.disabled=false;if(msg)msg.textContent='';});
  }
  function buildBox(){
    var w=document.createElement('div');w.className='ln24cb';
    w.innerHTML='<button type="button" class="ln24cb-link"></button><div class="ln24cb-row"><input type="text" maxlength="40" autocomplete="off"><button type="button"></button></div><div class="ln24cb-msg"></div><div class="ln24cb-on"><span></span><button type="button"></button><small></small></div>';
    w.querySelector('.ln24cb-link').textContent=T.have;
    w.querySelector('input').placeholder=T.ph;
    w.querySelector('.ln24cb-row button').textContent=T.apply;
    w.querySelector('.ln24cb-on button').textContent=T.remove;
    w.querySelector('.ln24cb-link').addEventListener('click',function(){w.classList.toggle('open');if(w.classList.contains('open'))setTimeout(function(){w.querySelector('input').focus();},50);});
    w.querySelector('.ln24cb-row button').addEventListener('click',function(){apply(w.querySelector('input').value);});
    w.querySelector('input').addEventListener('keydown',function(e){if(e.key==='Enter')apply(this.value);});
    w.querySelector('.ln24cb-on button').addEventListener('click',function(){S.cur=null;save(null);paint();});
    return w;
  }
  function mountBox(){
    var tries=0,iv=setInterval(function(){
      var btn=document.getElementById('ln24d-buybtn');
      if(btn||++tries>40){clearInterval(iv);
        if(btn&&!document.querySelector('.ln24cb')){box=buildBox();btn.parentNode.insertBefore(box,btn);paint();}
      }
    },250);
  }
  function mount(){
    document.body.appendChild(toast);
    var path=location.pathname.replace(/^\/(en|th|zh)(-[a-z]{2})?(?=\/)/,'');
    if(path.indexOf('/pages/number-detail')===0)mountBox();
    var q=new URLSearchParams(location.search);var c=q.get('code')||q.get('ref')||q.get('discount');
    if(c&&(!S.cur||S.cur.code!==c.toUpperCase())){
      /* creator link: validate quietly; show the toast on success */
      validate(c.trim().toUpperCase()).then(function(j){if(j&&j.valid){S.cur={code:j.code,percent:j.percent,ts:Date.now()};save(S.cur);paint();showToast(T.toast(j.code,j.percent));}}).catch(function(){});
    }
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',mount);else mount();
})();
